import { RENDERINGS_TAB_NAME } from 'src/lib/constants'
import { IPlan, IUnit } from 'src/types/filterPlans.interfaces'
import { IShell } from 'src/types/filterShells.interfaces'
import { IPlanElevation } from 'src/types/plan.interface'
import { splitMultiValued } from 'src/utils/conversion.util'

const ELEVATION_LIST_SEPARATOR = ', '

export const getFirstElevationIndexWithImage = (
  elevations: (IPlan | IUnit | IShell)[]
): number => {
  const index = elevations.findIndex(
    (el) =>
      el.supportingDocuments?.some((doc) => doc.fileTab === RENDERINGS_TAB_NAME)
  )
  return index >= 0 ? index : 0
}

/**
 * Every elevation's value, upper-cased and joined for display ('A5, A5T, B5').
 * Blank entries are skipped so a partly filled list never renders a stray comma.
 */
export const joinPlanElevationValues = (
  planElevations: IPlanElevation[] | undefined
): string =>
  (planElevations ?? [])
    .map((planElevation) => planElevation?.value?.toUpperCase())
    .filter(Boolean)
    .join(ELEVATION_LIST_SEPARATOR)

/**
 * The value a document's elevation field sorts by. The field is typed as a string,
 * but an Approved Regional Plan is one document covering several elevations, so it
 * arrives as a list - or with no elevation at all. Sorting on the raw field threw
 * "Cannot read properties of undefined (reading 'localeCompare')" and Search &
 * Compare showed that error instead of the plans. A missing elevation sorts first
 * as an empty key; a list sorts by its joined values ('A, AE').
 */
export const toElevationSortKey = (elevation: unknown): string =>
  splitMultiValued(elevation).join(ELEVATION_LIST_SEPARATOR)

export const compareElevations = (first: unknown, second: unknown): number =>
  toElevationSortKey(first).localeCompare(toElevationSortKey(second))
